<template>
  <div class="error">
    <strong>Error:</strong> {{ error }}
  </div>
</template>

<script>
export default {
  name: 'ErrorMessage',
  props: {
    error: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.error {
  background: #f8d7da;
  color: #721c24;
  padding: 15px;
  border-radius: 8px;
  margin: 20px;
  border: 1px solid #f5c6cb;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
}

@media (max-width: 768px) {
  .error {
    margin: 10px;
  }
}
</style>